import React from 'react';
import styled, { css } from 'styled-components';
import { useWindowSize } from 'hooks';
import { GatsbyImage } from 'gatsby-plugin-image';

function TextAndImageBlock({ image, imageTitle, imageAlt, children, flip, paddingTop }) {
  const { windowWidth } = useWindowSize();
  return (
    <Container className="fade-in">
      <Image image={image} title={imageTitle} alt={imageAlt} $flip={flip} />
      <Text $paddingTop={paddingTop} $flip={flip} $windowWidth={windowWidth}>
        <div>{children}</div>
      </Text>
    </Container>
  );
}

const Container = styled.section`
  color: red;
  display: grid;
  grid-column: 1/-1;
  grid-template-columns: subgrid;
  justify-items: center;
`;

const Image = styled(GatsbyImage)`
  grid-column: 1/-1;
  grid-row: 1;
  margin-top: 1.5rem;
  max-width: 470px;

  @media (width >= 1200px) {
    grid-column: ${({ $flip }) => ($flip ? '8/-1' : '1/6')};
    left: ${({ $flip }) => ($flip ? '-5px' : '5px')};
    margin-top: 100px;
    max-width: unset;
    position: relative;
    width: ${({ $flip }) => ($flip ? 'calc(100% + 30px)' : 'calc(100% + 30px)')};
  }
`;

const Text = styled.div`
  background-color: var(--connolly-grey);
  grid-column: 1/-1;
  grid-row: 2;

  @media (width >= 1200px) {
    grid-column: ${({ $flip }) => ($flip ? '1/7' : '7/13')};
    grid-row: 1;
    left: ${({ $flip }) => ($flip ? '5px' : '-5px')};
    width: ${({ $flip }) => ($flip ? 'calc(100% + 35px)' : 'calc(100% + 30px)')};
    position: relative;
  }

  ${({ $paddingTop, $flip, $windowWidth }) =>
    $flip && $windowWidth >= 1200
      ? css`
          align-items: center;
          display: flex;
          justify-content: center;
        `
      : css`
          padding: ${$paddingTop || '100px'} 0 37px;

          @media (width >= 1200px) {
            padding: ${$paddingTop || '100px'} 20px 55px 73px;
          }
        `}

  div {
    max-width: 470px;
  }

  h3 {
    font-size: 2rem;
  }

  p {
    font-size: 1rem;
    margin: 1.35em 0 2.35em;

    @media (width >= 1200px) {
      margin: 1.15em 0 4.15em;
    }
  }
`;

export default TextAndImageBlock;
